"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductInformationV2 = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("..");
const rich_content_1 = require("../rich-content");
const sales_ranks_1 = require("../sales-ranks");
const styles_1 = require("./styles");
const types_1 = require("./types");
function createRowsToRender(props) {
    const { labels, values } = props;
    if (labels == undefined || values == undefined) {
        return null;
    }
    const rowsToRender = [];
    for (const property in labels) {
        if (types_1.DsvLabels.includes(property)) {
            const labelToAdd = types_1.DsvSpecialRows.includes(property)
                ? props[`${property}Label`]
                : labels[property];
            const valueToAdd = types_1.DsvSpecialRows.includes(property)
                ? props[property]
                : values[property];
            if (labelToAdd && valueToAdd) {
                const rowLab = types_1.DsvSpecialRows.includes(property) ? (react_1.default.createElement(styles_1.StyledSpan, { bold: true, font: "base", color: "secondary", "data-cy": "attribute-label" }, props[`${property}Label`])) : (react_1.default.createElement(rich_content_1.RichContentElement, { bold: true, color: "secondary" }, labelToAdd));
                let rowVal;
                if (typeof valueToAdd === 'object' && 'html' in valueToAdd) {
                    rowVal = (0, __1.ServerRenderedHtmlParserWidget)(valueToAdd);
                }
                else if (typeof valueToAdd === 'object' && 'ranks' in valueToAdd) {
                    rowVal = (0, sales_ranks_1.SalesRanksElement)(valueToAdd);
                }
                else {
                    rowVal = types_1.DsvSpecialRows.includes(property) ? (react_1.default.createElement(styles_1.StyledSpan, { font: "base", color: "secondary", "data-cy": "attribute-label" }, props[`${property}`])) : (react_1.default.createElement(rich_content_1.RichContentElement, { color: "secondary" }, valueToAdd));
                }
                rowsToRender.push(react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(styles_1.StyledTh, null, rowLab),
                    react_1.default.createElement(styles_1.StyledTd, null, rowVal)));
            }
        }
    }
    return rowsToRender;
}
const ProductInformationV2 = (props) => {
    const { productInformation, labels, values, tenantId } = props;
    if (labels == undefined || values == undefined) {
        return null;
    }
    let rowsToRender;
    if (tenantId) {
        switch (tenantId) {
            default:
                rowsToRender = createRowsToRender(props);
        }
    }
    else {
        rowsToRender = createRowsToRender(props);
    }
    return rowsToRender ? (react_1.default.createElement(styles_1.StyledInformationContainer, { "data-cy": 'product-information' },
        react_1.default.createElement(__1.CanvasContainer, null,
            react_1.default.createElement(__1.ProductHeading, { title: productInformation })),
        react_1.default.createElement(styles_1.AttributeTable, { "data-cy": "product-information-table" },
            react_1.default.createElement("tbody", { "data-cy": "product-information-tbody" }, rowsToRender.map((row, index) => {
                return (react_1.default.createElement(styles_1.StyledTr, { key: index, "data-cy": "product-information-tr" }, row));
            }))))) : null;
};
exports.ProductInformationV2 = ProductInformationV2;
